import EventEmitter from 'eventemitter3';
import { Settings } from '../../Settings';
export class ViewerCounter extends EventEmitter {
    interval;
    EXPIRATION_MS = Settings.defaultHeartbeatInterval;
    UPDATE_INTERVAL_MS = Settings.viewerCounterUpdateInterval;
    // Map of nodeId to last heartbeat timestamp
    viewers = new Map();
    handleHeartbeat(heartbeat) {
        console.log('handleHeartbeat', heartbeat);
        this.viewers.set(heartbeat.nodeId, Date.now());
        this.emit('countChanged', this.viewers.size);
    }
    handleLeave(leave) {
        console.log('handleLeave', leave);
        this.viewers.delete(leave.nodeId);
        this.emit('countChanged', this.viewers.size);
    }
    getCount() {
        return this.viewers.size;
    }
    start() {
        if (this.interval)
            return;
        this.interval = setInterval(() => {
            const now = Date.now();
            for (const [nodeId, lastSeen] of this.viewers.entries()) {
                if (now - lastSeen > this.EXPIRATION_MS) {
                    this.viewers.delete(nodeId);
                    this.emit('countChanged', this.viewers.size);
                }
            }
        }, this.UPDATE_INTERVAL_MS);
    }
    stop() {
        if (this.interval) {
            clearInterval(this.interval);
            this.interval = undefined;
        }
    }
}
